module.exports = __webpack_public_path__ + "static/media/img.default.645366b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/apps/AppSearch/UI.AppBox/Icon/img.default.svg
// module id = 967
// module chunks = 0